import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Stack, Grid
} from "@mui/material";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import TaxApiViewController from "../../redux/actions/TaxSlabApiAction";


const AddTaxSlab = ({ show, handleClose, initialData = null, refreshList }) => {
  const dispatch = useDispatch();
  const { addTaxSlab, updateTaxSlab } = TaxApiViewController();
  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({
    regime: "old",
    min_income: "",
    max_income: "",
    tax_rate: "",
    fixed_tax: 0,
    standard_deduction: 0,
  });

  useEffect(() => {
  if (show) {
    if (initialData) {
      // Edit form: load existing data
      setInitialValues({
        location: initialData.location || "",
        regime: initialData.regime || "old",
        min_income: initialData.min_income || "",
        max_income: initialData.max_income || "",
        tax_rate: initialData.tax_rate || "",
        fixed_tax: initialData.fixed_tax || 0,
        standard_deduction: initialData.standard_deduction || 0,
      });
    } else {
      // Add form: reset to default blank values
      setInitialValues({
        regime: "old",
        min_income: "",
        max_income: "",
        tax_rate: "",
        fixed_tax: 0,
        standard_deduction: 0,
      });
    }
  }
}, [show, initialData]);


  const handleSubmit = (values, { resetForm }) => {
    const action = isEdit
      ? updateTaxSlab(initialData.id, values)
      : addTaxSlab(values);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
        refreshList();
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
      });
  };

  return (
    <Dialog open={show} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEdit ? "Edit Tax Slab" : "Add Tax Slab"}</DialogTitle>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
        {({ values, handleChange }) => (
          <Form>
           <DialogContent dividers>
  <Grid container spacing={2}>
    

    <Grid item xs={6}>
      <TextField
        label="Regime"
        name="regime"
        value={values.regime}
        onChange={handleChange}
        select
        fullWidth
      >
        <MenuItem value="old">Old Regime</MenuItem>
        <MenuItem value="new">New Regime</MenuItem>
      </TextField>
    </Grid>

    <Grid item xs={6}>
      <TextField
        label="Tax Rate (%)"
        name="tax_rate"
        type="number"
        value={values.tax_rate}
        onChange={handleChange}
        fullWidth
        required
      />
    </Grid>

    <Grid item xs={6}>
      <TextField
        label="Min Income"
        name="min_income"
        type="number"
        value={values.min_income}
        onChange={handleChange}
        fullWidth
        required
      />
    </Grid>

    <Grid item xs={6}>
      <TextField
        label="Max Income"
        name="max_income"
        type="number"
        value={values.max_income}
        onChange={handleChange}
        fullWidth
        required
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label="Fixed Tax (optional)"
        name="fixed_tax"
        type="number"
        value={values.fixed_tax}
        onChange={handleChange}
        fullWidth
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label="Standard Deduction"
        name="standard_deduction"
        type="number"
        value={values.standard_deduction}
        onChange={handleChange}
        fullWidth
      />
    </Grid>
  </Grid>
</DialogContent>

            <DialogActions>
              <Button onClick={handleClose} variant="outlined">Cancel</Button>
              <Button type="submit" variant="contained">
                {isEdit ? "Update" : "Create"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddTaxSlab;
